<template>
    <el-form
        ref="elFormRef"
        :model="model"
        :rules="rules"
        :label-position="labelPosition"
        :style="{ maxWidth: formMaxWidth }"
        :disabled="disabled"
        :inline="inline"
        :inline-message="inlineMessage"
        :status-icon="statusIcon"
        :label-width="labelWidth"
        hide-required-asterisk
        data-testid="form-container"
        class="redesign-base-form"
        v-bind="$attrs"
    >
        <slot />
    </el-form>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { FormPromiseType, LabelPositionType, TFormSize } from '@/components/RedesignBaseComponents/Form/base.form'
import { convertToUnit } from '@/helpers/util'
import { Form as ElForm } from 'element-ui'

interface IFProps {
    model?: object,
    rules?: object,
    labelPosition?: LabelPositionType
    maxWidth?: string | number,
    labelWidth?: string,
    size?: TFormSize
    disabled?: boolean
    scrollToError?: boolean
    inline?: boolean
    inlineMessage?: boolean
    statusIcon?: boolean
    validateOnRuleChange?: boolean
}

const props = withDefaults(
    defineProps<IFProps>(),
    {
        labelPosition: 'top',
        maxWidth: '100%',
        size: undefined,
        disabled: false,
        scrollToError: false,
        inline: undefined,
        inlineMessage: undefined,
        statusIcon: undefined,
        model: undefined,
        rules: undefined,
        labelWidth: undefined
    })

const elFormRef = ref()

const formMaxWidth = computed(() => {
    return convertToUnit(props.maxWidth)
})
/* Methods */
function validate (): Promise<FormPromiseType> {
    return new Promise(resolve => {
        if (!elFormRef.value) {
            resolve({
                isValid: true,
                invalidFields: []
            })
        } else {
            elFormRef.value?.validate((isValid: boolean, invalidFields?: unknown) => {
                resolve({
                    isValid,
                    invalidFields
                })
            })
        }
    })
}

function validateField (field: string | string[]): Promise<FormPromiseType> {
    return new Promise(resolve => {
        if (!elFormRef.value) {
            resolve({
                isValid: true,
                invalidFields: []
            })
        } else {
            elFormRef.value?.validateField(field, (isValid: boolean, invalidFields?: unknown) => {
                resolve({
                    isValid,
                    invalidFields
                })
            })
        }
    })
}
function resetFields (fields?: string | string[]): void {
    elFormRef.value?.resetFields(fields)
}
function clearValidate (props?: string | string[]): void {
    elFormRef.value?.clearValidate(props)
}
defineExpose({
    validate,
    validateField,
    resetFields,
    clearValidate
})
</script>

